<template>
  <div>
    <form @submit.prevent="handleSave">
      <b-row>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Nombre</label>
            <vs-input
              v-model="typeform.name"
              placeholder="Nombre"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="3">
          <div class="mb-3">
            <label>Fecha de inicio</label>
            <vs-input
              v-model="typeform.date"
              type="date"
              placeholder="Fecha"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="3">
          <div class="mb-3">
            <label>Hora de inicio</label>
            <vs-input
              v-model="typeform.hour"
              type="time"
              placeholder="Hour"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Rondas</label>
            <vs-input
              v-model="typeform.rounds"
              placeholder="Rondas"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Logo</label>
            <vs-input
              v-model="typeform.logo"
              placeholder="Logo"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Juego</label>
            <div>
              <select
                v-model="typeform.game"
                name="game"
                class="form-select border-0 shadow-lg"
                placeholder="Seleccione.."
              >
                <option disabled selected>{{ $t('helpers.select') }}...</option>
                <option
                  v-for="(item, index) in games"
                  :key="index"
                  :value="item.id"
                  :selected="typeform.game === item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Tipo de torneo</label>
            <div>
              <select
                v-model="typeform.type"
                name="type"
                class="form-select border-0 shadow-lg"
                placeholder="Seleccione.."
              >
                <option disabled selected>{{ $t('helpers.select') }}...</option>
                <option
                  v-for="(item, index) in types"
                  :key="index"
                  :value="item.id"
                  :selected="typeform.type === item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Tipo de Jugador</label>
            <div>
              <select
                v-model="typeform.playerType"
                name="playerType"
                class="form-select border-0 shadow-lg"
                placeholder="Seleccione.."
              >
                <option disabled selected>{{ $t('helpers.select') }}...</option>
                <option
                  v-for="(item, index) in playerType"
                  :key="index"
                  :value="item.id"
                  :selected="typeform.type === item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Apuesta minima</label>
            <vs-input
              v-model="typeform.minBet"
              placeholder="Apuesta minima"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>Max. Jugadores</label>
            <vs-input
              v-model="typeform.maxPlayers"
              placeholder="Max. Jugadores"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>PUNTOS INICIALES</label>
            <vs-input
              v-model="typeform.playerInitialPoints"
              placeholder="Puntos Iniciales"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>VALOR DEL TICKET</label>
            <vs-input
              v-model="typeform.ticketPrice"
              placeholder="Valor del Ticket"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="mb-3">
            <label>CANTIDAD A REPARTIR</label>
            <vs-input
              v-model="typeform.winningAmount"
              placeholder="Cantidad a Repartir"
              border
              class="shadow-lg"
            />
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <vs-checkbox v-model="typeform.hasMaxPlayers">
            TIENE MAX. JUGADORES
          </vs-checkbox>
        </b-col>
        <b-col sm="12" md="6">
          <vs-checkbox v-model="typeform.playerRetry"> REINTENTOS </vs-checkbox>
        </b-col>
      </b-row>
      <div class="mb-3 mt-3">
        <div class="d-flex">
          <vs-button>Guardar</vs-button>
          <vs-button @click="$emit('closeModa')" success type="button">
            Cancelar
          </vs-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PageForm',
  props: {
    typeform: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        start_date: '',
        hour: '',
        rounds: 0,
        logo: '',
        type: '',
        game: '',
        minBet: 0,
        maxPlayers: 0,
        hasMaxPlayers: false,
        playerRetry: false,
        playerInitialPoints: 2000,
        ticketPrice: 0,
        winningAmount: 0,
        playerType: '',
      }),
    },
  },
  data() {
    return {
      types: [
        { id: 'FREE', name: 'Gratis' },
        { id: 'GUARANTEED', name: 'Garantizado' },
        { id: 'CONDITIONED', name: 'Condicionado' },
      ],
      playerType: [
        { id: 'GOLD', name: 'Gold' },
        { id: 'PLATINUM', name: 'Platinum' },
        { id: 'DIAMOND', name: 'Diamond' },
        { id: 'SILVER', name: 'Silver' },
        { id: 'BRONZE', name: 'Bronze' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      success: 'tournaments/isSuccess',
      games: 'games/getFormattedGames',
      text: 'tournaments/getMessage',
    }),
  },
  methods: {
    async handleSave() {
      const formattedDate = new Date(
        this.typeform.date + 'T' + this.typeform.hour
      );

      const data = {
        ...this.typeform,
        start_date: formattedDate.toISOString(),
      };

      if (this.typeform.id) await this.updateTournament(data);
      else await this.createTournament({ ...data, count: 0 });

      if (!this.success)
        return this.$swal.fire({
          title: 'Error',
          text: this.text,
          icon: 'error',
        });

      this.$swal.fire({
        title: 'Éxito',
        text: this.text,
        icon: 'success',
      });
      this.$emit('closeModa');
    },
    closeModa() {
      this.$emit('closeModa');
    },
    ...mapActions({
      createTournament: 'tournaments/createTournament',
      updateTournament: 'tournaments/updateTournament',
    }),
  },
};
</script>
